import { Controller } from 'stimulus';

class Toggleable extends Controller {
  connect() {
    this.initialHeight = parseInt(this.data.get('initial-height'), 10);
    this.height = $(this.contentTarget)[0].scrollHeight;

    $(this.togglerTarget).toggle(this.height > this.initialHeight);
    $(this.contentTarget).css('height', this.height > this.initialHeight ? this.initialHeight : 'auto');
  }

  toggle() {
    const isOpen = $(this.togglerTarget).hasClass('is-open');

    this.toggleContent(isOpen);
    this.toggleTogglerText(isOpen);
  }

  toggleContent(state) {
    $(this.contentTarget)
      .css('height', state ? this.initialHeight : this.height)
      .toggleClass('is-open', !state)
      .attr('aria-expanded', !state);
  }

  toggleTogglerText(state) {
    $(this.togglerTarget)
      .attr('aria-expanded', !state)
      .toggleClass('is-open', !state)
      .find('span')
      .text(!state ? this.data.get('collapsed-text') : this.data.get('expanded-text'));
  }
}

Toggleable.targets = [
  'toggler',
  'content',
];

export default Toggleable;
